module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/december-a9e3cc8c0114019cb4fb1ffc6879277b.png";